var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDarkMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 44,
    viewBox: "0 0 222 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8315_150460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.424 27.8153H145.649V30.7419H134.137V27.9667C134.137 25.641 135.207 24.1685 137.525 22.7419L140.739 20.7419C141.685 20.141 142.284 19.3933 142.284 18.2649C142.284 16.9896 141.36 15.9667 139.719 15.9667C138.174 15.9667 137.177 17.1181 137.177 18.4162H134.114C134.114 15.664 136.085 12.9163 139.769 12.9163C143.454 12.9163 145.598 15.3153 145.598 18.141C145.598 20.4162 144.501 21.9392 142.435 23.1915L139.097 25.2144C137.826 26.0126 137.429 26.6639 137.429 27.563V27.8153H137.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2765 13.2373H51.3939V30.7373H56.2765C61.6848 30.7373 65.0221 27.3382 65.0221 21.985C65.0221 16.6318 61.6848 13.2327 56.2765 13.2327V13.2373ZM56.2765 29.3611H52.9117V14.641H56.2765C60.6607 14.641 63.454 17.5676 63.454 21.9896C63.454 26.4116 60.6379 29.3657 56.2765 29.3657V29.3611ZM68.7161 13.2373H70.2339V30.7373H68.7161V13.2373ZM85.2153 18.3107C85.2153 15.2373 83.0986 13.2373 79.6607 13.2373H73.9324V30.7373H75.4502V23.485H79.8116L83.8713 30.7373H85.6634L81.4025 23.3382C83.5467 22.8153 85.2153 20.9391 85.2153 18.3153V18.3107ZM79.6607 22.1088H75.4502V14.6089H79.5876C82.1797 14.6089 83.6244 16.1593 83.6244 18.3107C83.6244 20.7602 81.9557 22.1088 79.6607 22.1088ZM90.8157 29.3336H99.1362V30.7327H89.2933V13.2373H98.935V14.6364H90.8111V21.1364H97.8378V22.5125H90.8111V29.3382L90.8157 29.3336ZM103.155 21.985C103.155 26.3841 106.318 29.6088 110.479 29.6088C113.468 29.6088 116.033 28.0079 117.007 25.1318H118.703C117.583 28.7052 114.47 31.0584 110.479 31.0584C105.322 31.0584 101.582 27.1593 101.582 21.985C101.582 16.8107 105.345 12.9116 110.479 12.9116C114.488 12.9116 117.528 15.3107 118.703 18.8382H117.057C116.061 15.9896 113.496 14.3612 110.479 14.3612C106.318 14.3612 103.155 17.6364 103.155 21.985ZM119.595 13.2327H131.929V14.6318H126.521V30.7327H125.003V14.641H119.595V13.2419V13.2327ZM150.417 21.985C150.417 26.3841 153.581 29.6088 157.741 29.6088C160.731 29.6088 163.295 28.0079 164.269 25.1318H165.965C164.845 28.7052 161.727 31.0584 157.741 31.0584C152.584 31.0584 148.844 27.1593 148.844 21.985C148.844 16.8107 152.607 12.9116 157.741 12.9116C161.75 12.9116 164.79 15.3107 165.965 18.8382H164.319C163.323 15.9896 160.758 14.3612 157.741 14.3612C153.581 14.3612 150.417 17.6364 150.417 21.985ZM174.327 13.2327L167.501 30.7327H169.097L170.816 26.3336H179.662L181.358 30.7327H182.977L176.174 13.2327H174.331H174.327ZM171.36 24.907L175.145 15.0079H175.296L179.109 24.907H171.36ZM197.949 18.3061C197.949 15.2327 195.832 13.2327 192.394 13.2327H186.666V30.7327H188.184V23.4804H192.545L196.605 30.7327H198.397L194.136 23.3336C196.28 22.8107 197.949 20.9345 197.949 18.3107V18.3061ZM192.394 22.1043H188.184V14.6043H192.321C194.913 14.6043 196.358 16.1547 196.358 18.3061C196.358 20.7556 194.689 22.1043 192.394 22.1043ZM211.934 29.329V30.7281H202.091V13.2373H211.733V14.6364H203.609V21.1364H210.635V22.5125H203.609V29.3382H211.929L211.934 29.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0063 1.64105L21.1704 9.50342L32.874 21.2465L40.7099 13.3841C42.8906 11.1961 42.8906 7.64562 40.7099 5.45756L36.9062 1.64105C34.7255 -0.547017 31.187 -0.547017 29.0063 1.64105Z",
    fill: "url(#paint0_linear_8315_150460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63553 37.0309L5.43918 40.8474C7.61988 43.0355 11.1584 43.0355 13.3391 40.8474L21.175 32.985L9.47142 21.2419L1.63553 29.1043C-0.545175 31.2924 -0.545175 34.8428 1.63553 37.0309Z",
    fill: "url(#paint1_linear_8315_150460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 40.8474L40.7099 37.0309C42.8906 34.8428 42.8906 31.2924 40.7099 29.1043L32.874 21.2419L21.1704 32.985L29.0063 40.8474C31.187 43.0355 34.7255 43.0355 36.9062 40.8474Z",
    fill: "url(#paint2_linear_8315_150460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43918 1.64105L1.63553 5.45756C-0.545175 7.64562 -0.545175 11.1961 1.63553 13.3841L9.47142 21.2465L21.175 9.50342L13.3391 1.64105C11.1584 -0.547017 7.61988 -0.547017 5.43918 1.64105Z",
    fill: "url(#paint3_linear_8315_150460)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8315_150460",
    x1: 27.7253,
    y1: 46.7226,
    x2: 22.3048,
    y2: -0.544909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#31A9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8315_150460",
    x1: 8.46948,
    y1: 48.674,
    x2: 3.04896,
    y2: 1.40653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#008966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2EB692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8315_150460",
    x1: 3.23213,
    y1: 27.4575,
    x2: 50.3487,
    y2: 22.0906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9F6192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8315_150460",
    x1: 1.28728,
    y1: 8.13653,
    x2: 48.4038,
    y2: 2.76965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F26836"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8315_150460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkMd);
export default __webpack_public_path__ + "static/media/logo-dark-md.3990f09c35e0be4596894716a2c80859.svg";
export { ForwardRef as ReactComponent };